<template>
  <!-- THE ORGANIZATION INFORMATION IF THE SUPERADMIN GET HERE FROM ALL THE USERS -->
  <div class="pa-2 mb-2">
    <h4 class="settings-h4">Account</h4>
    <div class="wrapper-2 pa-2 pos-relative">
      <v-select
        v-model="profile.role"
        :items="computedRoles"
        :disabled="isFieldDisabled || actionType === 'edit'"
        label="Role"
        class="mr-4 mw-160"
        :class="[actionType === 'add' && 'required']"
        hide-details
      ></v-select>

      

      <!-- THIS IS SHOWN WHEN THE SUPER ADMIN COME TO COMPONENT FROM ALL THE USERS -->
      <AccountOrganization
        v-if="isShowAccountOrganization"
        :profile="profile"
        :actionType="actionType"
        :isFieldDisabled="isFieldDisabled"
      />

      <!--LICENSES -->
      <Licenses
        :profile="profile"
        :freezedProfile="freezedProfile"
        :actionType="actionType"
      />

      <!--REPORT LEVEL-->
      <ReportSection
        v-if="isShowAddReport"
        :isFieldDisabled="isFieldDisabled"
        :profile="profile"
      />

      <!--LANGUAGE AND CASUAL SETTINGS -->
      <LanguageAndCasualSettings
        :actionType="actionType"
        :profile="profile"
        :isFieldDisabled="isFieldDisabled"
      />

      <OnlineHelp page="singleUser" section="account" title="Account" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

//Base components
import OnlineHelp from '@/components/BaseComponents/OnlineHelp/OnlineHelp.vue'

//Childrens
import PersonalManagement from './Children/PersonalManagement/PersonalManagement.vue'
import AccountOrganization from './Children/AccountOrganization/AccountOrganization.vue'
import Licenses from './Children/Licenses/Licenses.vue'
import LanguageAndCasualSettings from './Children/LanguageAndCasualSettings/LanguageAndCasualSettings.vue'
import ReportSection from './Children/ReportSection/ReportSection.vue'

export default {
  name: 'Personal',

  props: {
    actionType: String,
    isFromUsers: Boolean,
    // accountType: String,
    profile: Object,
    freezedProfile: Object,
    isFieldDisabled: Boolean,
  },
  components: {
    PersonalManagement,
    AccountOrganization,
    Licenses,
    LanguageAndCasualSettings,
    OnlineHelp,
    ReportSection,
  },

  watch: {
    'profile.role': function (n, o) {
      // if (o) {
      //   this.profile.license = ''
      // }
      if (n === 'Individual' || n === 'SuperAdmin') {
        this.profile.license = 'Website'
      }
    },
  },
  computed: {
    ...mapGetters(['loggedUser']),
    isShowAddReport() {
      if (this.profile.role === 'SuperAdmin') return false
      else if (this.profile.role === 'Individual') return false
      else if (this.profile.license === 'API') return false
      return true
    },

    isShowAccountOrganization() {
      if (!this.isFromUsers) return false
      else if (this.profile.role === 'Individual') false
      else if (this.profile.role === 'SuperAdmin') false
      return true
    },
    computedRoles() {
      if (this.loggedUser.role === 'SuperAdmin' && this.isFromUsers) {
        return [
          {
            text: 'Registered User',
            value: 'User',
          },
          {
            text: 'Individual User',
            value: 'Individual',
          },
          {
            text: 'Host Admin',
            value: 'Admin',
          },
          {
            text: 'Super Admin',
            value: 'SuperAdmin',
          },
        ]
      } else
        return [
          {
            text: 'Registered User',
            value: 'User',
          },
          {
            text: 'Host Admin',
            value: 'Admin',
          },
        ]
    },
  },
}
</script>
